const gitInfo= {"buildDate": "2023-03-27T16:08:57","commitHash":"7a96374","gitTag": "1.4.1","commitDate":"Mon, 27 Mar 2023 16:07:22 +0100","gitBranch":"master","gitCommitsSinceLastTag":0};
export default gitInfo
